import React from 'react';
import { connect } from 'react-redux';
import { Table, Input, Loader, Button, Icon, Dropdown } from 'semantic-ui-react';
import {
  DeleteButton,
  EditButton,
  Img,
  ButtonBlock,
  ProductNameBlock,
  Label,
  LoaderBlock,
  SortBlock,
  ColumnName,
  TagsGroup,
  NameBlock,
  FooterBlock,
  DishTitleLabel,
  ButtonGroupBlock,
  MealTagsBlock,
  DishCountBlock,
} from './DishListPageStyles';
import {
  H1,
  StyledLink,
  LinkBlock,
  TableBlock,
  H2,
} from '../CreateProductPage/CreateProductStyles';
import TagsBlock from '../TagsBlock';
import * as action from '../../../actions/newYouslim';
import DeleteConfirmPopup from '../../Common/DeleteConfirmPopup';
import SortButton from '../SortButton';
import EditIcon from '../../../images/edit_icon.png';
import {
  dish_tags_id,
  eating_tags_id,
  dish_portion_count,
  product_tags_id,
  defualt_portion,
  defaultMeasureOfWeightlist,
  breakfastTagId,
  lunchTagId,
  dinnerTagId,
  breakfastSnackId,
  lunchSnackId,
  dinnerSnackId,
  defaulIsDraftArray,
} from '../youslim2.0_Constants';
import debounce from '../../../utils/debounce';
import SortButtonCroup from '../SortButtonGroup';
import DishInfoModal from '../DishInfoModal';
import ProductsTagsBlockForSearch from '../TagsBlock/ClientTagsBlock';
import Navbar from '../Navigation/Navbar';

const DishListPage = React.memo(
  ({
    isSearchDishLoading,
    getRecipeTags,
    getEatingTags,
    getProductTags,
    allRecipeTags,
    allEatingTags,
    allTags,
    getDishListByName,
    setCurrentDish,
    dishes,
    deleteDish,
    getProductsByName,
    products,
    productToFind,
    isDishLoading,
  }) => {
    const [choosedTags, setChoosedTags] = React.useState([]);
    const [isShowDeletePopup, setIsShowDeletePopup] = React.useState(false);
    const [dishCurrentName, setDishCurrentName] = React.useState('');
    const [dishList, setDishList] = React.useState([...dishes]);
    const [isOpenDishInfo, setIsOpenDishInfo] = React.useState([false]);
    const [defaultPortion, setDefaultPortion] = React.useState('small');
    const [isShowDishInfoModal, setIsShowDishInfoModal] = React.useState(false);
    const [currentProduct, setCurrentProduct] = React.useState([]);
    const [dishCurrentId, setDishCurrentId] = React.useState('');
    const [tagsSearchRule, setTagsSearchRule] = React.useState(false);
    const [productsRows, setProductsRows] = React.useState(
      productToFind && productToFind.length ? productToFind : [],
    );
    const [productList, setProductList] = React.useState([]);
    const [currentListIndex, setCurrentListIndex] = React.useState(0);
    const [isDraftSelectValue, setIsDraftSelectValue] = React.useState('all');
    const [dishCount, setDishCount] = React.useState(0);

    React.useEffect(() => {
      getRecipeTags(dish_tags_id);
      getEatingTags(eating_tags_id);
      getProductTags(product_tags_id);
      getDishListByName();
      getProductsByName();
    }, []);

    const sortProductByAlphabet = (oldProductsList, newProductsItems) => {
      // eslint-disable-next-line no-unused-expressions
      oldProductsList.sort(function (a, b) {
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        return 0;
      });

      oldProductsList.forEach((product) => {
        newProductsItems.push({
          key: product.id,
          value: product.id,
          text: product.name,
        });
      });
    };

    React.useEffect(() => {
      const newProductsItems = [];
      const newProductsList = productList;
      const oldProductsList = products;
      sortProductByAlphabet(oldProductsList, newProductsItems);
      newProductsList[currentListIndex] = newProductsItems;
      setProductList(...newProductsList);
    }, [products, setProductList, currentListIndex, setCurrentListIndex]);

    const filterByProductAndTags = React.useCallback(
      (productsArray, choosedTags, dishes) => {
        let dishListArray = dishes;
        const newDishList = [];
        if (!productsArray.length && !choosedTags.length && isDraftSelectValue === 'all')
          return setDishList([...dishes]);
        if (productsArray.length) {
          dishListArray.forEach((dish) => {
            const dishProductsIds = [];
            dish.products.forEach((product, i) => {
              dishProductsIds.push(product.product_id);
              if (dish.products.length - 1 === i) {
                if (productsArray.every((product_id) => dishProductsIds.includes(product_id))) {
                  newDishList.push(dish);
                }
              }
            });
            setDishList([...newDishList]);
          });
        }
        const newTagsDishList = [];
        if (choosedTags.length) {
          if (newDishList.length) dishListArray = newDishList;

          dishListArray.forEach((dish) => {
            if (!tagsSearchRule) {
              let isDishHaveTags = false;
              dish.tags.forEach((tag) => {
                if (choosedTags.indexOf(tag.id) !== -1) {
                  isDishHaveTags = true;
                }
              });
              if (isDishHaveTags && newTagsDishList.indexOf(dish) === -1) {
                newTagsDishList.push(dish);
              }
            } else {
              const dishTagsIds = [];
              dish.tags.forEach((tag, i) => {
                dishTagsIds.push(tag.id);
                if (dish.tags.length - 1 === i) {
                  if (choosedTags.every((tag) => dishTagsIds.includes(tag))) {
                    newTagsDishList.push(dish);
                  }
                }
              });
            }
          });
          if (newTagsDishList.length) {
            setDishList([...newTagsDishList]);
          } else setDishList([...newDishList]);
        }
        const newIsDraftDish = [];
        if (isDraftSelectValue !== 'all') {
          if (newDishList.length) dishListArray = newDishList;
          if (newTagsDishList.length) dishListArray = newTagsDishList;

          dishListArray.forEach((dish) => {
            if (dish.is_draft !== isDraftSelectValue) return;
            newIsDraftDish.push(dish);
          });
          if (newIsDraftDish.length) {
            setDishList([...newIsDraftDish]);
          } else if (newTagsDishList.length) {
            setDishList([...newTagsDishList]);
          } else setDishList([...newDishList]);
        }
      },
      [setDishList, dishList, tagsSearchRule, isDraftSelectValue],
    );

    React.useEffect(() => {
      setDishList([...dishes]);
      const dishCount = [];
      dishes.forEach(() => {
        dishCount.push(false);
      });
      setIsOpenDishInfo([...dishCount]);
      filterByProductAndTags(productsRows, choosedTags, dishes);
    }, [dishes]);

    React.useEffect(() => {
      filterByProductAndTags(productsRows, choosedTags, dishes);
    }, [choosedTags, tagsSearchRule, isDraftSelectValue]);

    React.useEffect(() => {
      if (!isDishLoading) {
        setIsShowDeletePopup(false);
      }
    }, [isDishLoading]);

    const confirmDeleting = React.useCallback(
      (name, id) => {
        setDishCurrentName(name);
        setDishCurrentId(id);
        setIsShowDeletePopup(true);
      },
      [setDishCurrentName, setDishCurrentId, setIsShowDeletePopup],
    );

    const onSearchProduct = React.useCallback(
      debounce((name) => {
        getDishListByName(name);
      }, 1000),
      [getDishListByName],
    );

    const onEditClick = React.useCallback(
      (dish) => {
        const newDish = [...dish];
        newDish.name = dish.title;
        newDish.id = dish.id;
        newDish.products = dish.products.map((product) => {
          return {
            name: product.name,
            product_id: product.id,
            small: product.small,
            medium: product.medium,
            big: product.big,
            large: product.large,
            measure:
              defaultMeasureOfWeightlist[product.measure_id - 1] &&
              defaultMeasureOfWeightlist[product.measure_id - 1].text,
            error: false,
          };
        });
        newDish.tags = dish.tags;
        newDish.dish_recipes = dish.dish_recipes;
        newDish.description = dish.description;
        newDish.file = dish.file;
        newDish.cooking_time = dish.cooking_time;

        setCurrentDish(newDish);
      },
      [setCurrentDish, defaultMeasureOfWeightlist],
    );

    const SortNutrients = React.useCallback(
      (sortArray, isFromMoreToLess, nutrient) => {
        sortArray.sort(function (a, b) {
          return isFromMoreToLess
            ? b.recipes[defaultPortion][nutrient] - a.recipes[defaultPortion][nutrient]
            : a.recipes[defaultPortion][nutrient] - b.recipes[defaultPortion][nutrient];
        });
        setDishList([...sortArray]);
      },
      [defaultPortion, setDishList],
    );

    const SortByName = React.useCallback(
      (sortArray) => {
        sortArray.sort(function (a, b) {
          if (a && b) {
            if (a.title > b.title) {
              return 1;
            }
            if (a.title < b.title) {
              return -1;
            }
          }
          return 0;
        });

        setDishList([...sortArray]);
      },
      [setDishList],
    );

    const ClearSort = React.useCallback(() => {
      setDishList([...dishes]);
    }, [setDishList]);

    const setIsOpenDishInfoArrayUp = React.useCallback(
      (index) => {
        const dishArray = isOpenDishInfo;
        dishArray.splice(index, 1, false);
        setIsOpenDishInfo([...dishArray]);
      },
      [isOpenDishInfo, setIsOpenDishInfo],
    );

    const setIsOpenDishInfoArrayDown = React.useCallback(
      (index) => {
        const dishArray = isOpenDishInfo;
        dishArray.splice(index, 1, true);
        setIsOpenDishInfo([...dishArray]);
      },
      [isOpenDishInfo, setIsOpenDishInfo],
    );

    const openDishInfoModal = React.useCallback(
      (dish) => {
        setIsShowDishInfoModal(true);
        setDishCurrentName(dish.title);
        const newDish = [...dish];
        newDish.products = dish.products.map((product) => {
          return {
            name: product.name,
            product_id: product.id,
            small: product.small,
            medium: product.medium,
            large: product.large,
            big: product.big,
            measure: product.measure,
            error: false,
          };
        });
        setCurrentProduct(newDish.products);
      },
      [setCurrentProduct, setDishCurrentName, setIsShowDishInfoModal],
    );

    const onDelete = React.useCallback(() => {
      deleteDish(dishCurrentId);
    }, [deleteDish, dishCurrentId]);

    const onChangeProduct = React.useCallback(
      (data, dishes) => {
        filterByProductAndTags(data.value, choosedTags, dishes);
        setProductsRows([...data.value]);
      },
      [setProductsRows, choosedTags],
    );

    const onIsDraftSelect = React.useCallback(
      (data) => {
        setIsDraftSelectValue(data.value);
      },
      [setIsDraftSelectValue],
    );

    return (
      <React.Fragment>
        <Navbar> </Navbar>
        <H1>Список блюд</H1>
        <ProductNameBlock>
          <Label>Поиск блюда</Label>
          <Input
            placeholder="Введите название блюда"
            className="product-name-input"
            onChange={(e) => onSearchProduct(e.target.value)}
          />
          <Dropdown
            placeholder="Найти по статусу публикации"
            fluid
            style={{ width: '30%' }}
            search
            selection
            clearable
            options={defaulIsDraftArray}
            value={isDraftSelectValue}
            onChange={(e, data) => onIsDraftSelect(data)}
          />
        </ProductNameBlock>
        <ProductNameBlock>
          <Label>
            Поиск блюда <br /> по продуктам
          </Label>
          <Dropdown
            placeholder="Выберите продукт"
            // id="choose-product-input"
            fluid
            search
            selection
            clearable
            multiple
            options={productList}
            value={productsRows}
            onChange={(e, data) => onChangeProduct(data, dishes)}
          />
        </ProductNameBlock>
        <TagsGroup>
          <TagsBlock
            allTags={allRecipeTags}
            choosedTags={choosedTags}
            setChoosedTags={setChoosedTags}
            height="320px"
            flexBasis="6%"
            width="15%"
            title="Теги блюда"
          />
          <TagsBlock
            allTags={allEatingTags}
            choosedTags={choosedTags}
            setChoosedTags={setChoosedTags}
            height="300px"
            flexBasis="6%"
            width="15%"
            title="Приёмы пищи"
          />
          <ProductsTagsBlockForSearch
            allTags={allTags}
            choosedTags={choosedTags}
            setChoosedTags={setChoosedTags}
            height="300px"
            flexBasis="7%"
            width="100%"
          />
        </TagsGroup>
        <ButtonGroupBlock>
          <Button.Group>
            <Button
              className={!tagsSearchRule ? 'or_button_active' : 'or_button'}
              active={!tagsSearchRule}
              onClick={() => setTagsSearchRule(false)}
            >
              Искать теги с правилом ИЛИ
            </Button>
            <Button.Or />
            <Button
              className={tagsSearchRule ? 'and_button_active' : 'and_button'}
              active={tagsSearchRule}
              onClick={() => setTagsSearchRule(true)}
            >
              Искать теги с правилом И
            </Button>
          </Button.Group>
        </ButtonGroupBlock>
        {dishList.length ? <DishCountBlock>Количество блюд: {dishList.length}</DishCountBlock> : ''}
        <TableBlock>
          {dishList.length ? (
            <Table celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>
                    <ButtonBlock>
                      <DishTitleLabel>
                        Название <br /> Продукта
                      </DishTitleLabel>
                      <SortButton
                        onClickSort={SortByName}
                        iconName="sort alphabet down"
                        arrayForSort={dishList}
                      />
                    </ButtonBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell />
                  <Table.HeaderCell>
                    Выберите <br /> порцию
                    <Dropdown
                      placeholder="Select Friend"
                      fluid
                      selection
                      compact
                      value={defaultPortion}
                      style={{ fontSize: '12px', minWidth: '80px', marginTop: '5px' }}
                      onChange={(e, data) => setDefaultPortion(data.value)}
                      options={defualt_portion}
                    />
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <SortBlock>
                      <ColumnName>Кал</ColumnName>
                      <SortButtonCroup
                        onClickSort={SortNutrients}
                        arrayForSort={dishList}
                        nutrient="calories"
                      />
                    </SortBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <SortBlock>
                      <ColumnName>Жб</ColumnName>
                      <SortButtonCroup
                        onClickSort={SortNutrients}
                        arrayForSort={dishList}
                        nutrient="animal_protein"
                      />
                    </SortBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <SortBlock>
                      <ColumnName>Pб</ColumnName>
                      <SortButtonCroup
                        onClickSort={SortNutrients}
                        arrayForSort={dishList}
                        nutrient="vegetable_protein"
                      />
                    </SortBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <SortBlock>
                      <ColumnName>Нж</ColumnName>
                      <SortButtonCroup
                        onClickSort={SortNutrients}
                        arrayForSort={dishList}
                        nutrient="saturated_fat"
                      />
                    </SortBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <SortBlock>
                      <ColumnName>Ненж</ColumnName>
                      <SortButtonCroup
                        onClickSort={SortNutrients}
                        arrayForSort={dishList}
                        nutrient="unsaturated_fats"
                      />
                    </SortBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <SortBlock>
                      <ColumnName>
                        Простые <br /> углеводы
                      </ColumnName>
                      <SortButtonCroup
                        onClickSort={SortNutrients}
                        arrayForSort={dishList}
                        nutrient="simple_carbohydrates"
                      />
                    </SortBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <SortBlock>
                      <ColumnName>
                        Сложные
                        <br /> углеводы
                      </ColumnName>
                      <SortButtonCroup
                        onClickSort={SortNutrients}
                        arrayForSort={dishList}
                        nutrient="complex_carbohydrates"
                      />
                    </SortBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <SortBlock>
                      <ColumnName>Кл</ColumnName>
                      <SortButtonCroup
                        onClickSort={SortNutrients}
                        arrayForSort={dishList}
                        nutrient="cellulose"
                      />
                    </SortBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <ColumnName>
                      Теги <br /> продуктов
                    </ColumnName>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <ColumnName>Теги</ColumnName>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <Button size="mini" onClick={() => ClearSort()}>
                      Сбросить <br /> сортировку
                    </Button>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {dishList.map((dish, index) => {
                  if (isOpenDishInfo[index]) {
                    const productTagsArray = [];
                    const dishTagsArray = [];
                    const dishTagsId = [];

                    dish.tags.forEach((tag) => {
                      if (tag.tag_category_id === 1) return productTagsArray.push(` ${tag.name}`);
                    });
                    dish.tags.forEach((tag) => {
                      if (tag.tag_category_id === 2) return dishTagsArray.push(` ${tag.name}`);
                      if (tag.tag_category_id === 3) return dishTagsId.push(tag.id);
                    });

                    return Object.keys(dish.recipes).map((portion, i) => (
                      <Table.Row key={dish && dish.id + index + portion}>
                        {i === 0 && (
                          <React.Fragment>
                            <Table.Cell rowSpan={dish_portion_count}>
                              <NameBlock>
                                {dish && dish.title}
                                <Icon
                                  size="big"
                                  name="info circle"
                                  color="blue"
                                  onClick={() => openDishInfoModal(dish)}
                                />
                              </NameBlock>
                            </Table.Cell>
                            <Table.Cell rowSpan={dish_portion_count}>
                              <Button
                                onClick={() => setIsOpenDishInfoArrayUp(index)}
                                color="blue"
                                icon
                                size="tiny"
                              >
                                <Icon name="long arrow alternate up" />
                              </Button>
                            </Table.Cell>
                          </React.Fragment>
                        )}
                        <Table.Cell style={{ borderLeft: '0.5px solid #e8e9e9' }}>
                          {dish && portion}
                        </Table.Cell>
                        <Table.Cell>{dish && dish.recipes[portion].calories}</Table.Cell>
                        <Table.Cell className="protein_cell">
                          {dish && dish.recipes[portion].animal_protein}
                        </Table.Cell>
                        <Table.Cell className="protein_cell">
                          {dish && dish.recipes[portion].vegetable_protein}
                        </Table.Cell>
                        <Table.Cell className="fat_cell">
                          {dish && dish.recipes[portion].saturated_fat}
                        </Table.Cell>
                        <Table.Cell className="fat_cell">
                          {dish && dish.recipes[portion].unsaturated_fats}
                        </Table.Cell>
                        <Table.Cell className="arbohydrates_cell">
                          {dish && dish.recipes[portion].simple_carbohydrates}
                        </Table.Cell>
                        <Table.Cell className="arbohydrates_cell">
                          {dish && dish.recipes[portion].complex_carbohydrates}
                        </Table.Cell>
                        <Table.Cell>{dish && dish.recipes[portion].cellulose}</Table.Cell>
                        {i === 0 && (
                          <React.Fragment>
                            <Table.Cell className="product_tags_block" rowSpan={dish_portion_count}>
                              {dish && productTagsArray.length && (
                                <div className="product_tags" data-title={productTagsArray}>
                                  {productTagsArray[0]}
                                </div>
                              )}
                            </Table.Cell>
                            <Table.Cell className="product_tags_block" rowSpan={dish_portion_count}>
                              {dish && dishTagsArray.length && (
                                <React.Fragment>
                                  <MealTagsBlock>
                                    <Icon
                                      name="circle"
                                      size="small"
                                      color={dishTagsId.includes(breakfastTagId) ? 'blue' : 'grey'}
                                    />
                                    <Icon
                                      name="circle"
                                      size="tiny"
                                      color={
                                        dishTagsId.includes(breakfastSnackId) ? 'blue' : 'grey'
                                      }
                                    />
                                    <Icon
                                      name="circle"
                                      size="small"
                                      color={dishTagsId.includes(lunchTagId) ? 'blue' : 'grey'}
                                    />
                                    <Icon
                                      name="circle"
                                      size="tiny"
                                      color={dishTagsId.includes(lunchSnackId) ? 'blue' : 'grey'}
                                    />
                                    <Icon
                                      name="circle"
                                      size="small"
                                      color={dishTagsId.includes(dinnerTagId) ? 'blue' : 'grey'}
                                    />
                                    <Icon
                                      name="circle"
                                      size="tiny"
                                      color={dishTagsId.includes(dinnerSnackId) ? 'blue' : 'grey'}
                                    />
                                  </MealTagsBlock>
                                  <div className="product_tags" data-title={dishTagsArray}>
                                    {`${dishTagsArray[0]}  ${dishTagsArray.length > 1 ? '+' : ''}`}
                                  </div>
                                </React.Fragment>
                              )}
                            </Table.Cell>
                            <Table.Cell rowSpan={dish_portion_count}>
                              <ButtonBlock>
                                <EditButton
                                  onClick={() => onEditClick(dish)}
                                  to={`/youslim2.0/dish/${dish.id}/edit`}
                                  target="_blank"
                                >
                                  <Img src={EditIcon} alt="edit" />
                                </EditButton>
                                <DeleteButton onClick={() => confirmDeleting(dish.title, dish.id)}>
                                  x
                                </DeleteButton>
                              </ButtonBlock>
                            </Table.Cell>
                          </React.Fragment>
                        )}
                      </Table.Row>
                    ));
                    // eslint-disable-next-line no-else-return
                  } else {
                    const productTagsArray = [];
                    const dishTagsArray = [];
                    const dishTagsId = [];

                    dish.tags.forEach((tag) => {
                      if (tag.tag_category_id === 1) return productTagsArray.push(` ${tag.name}`);
                    });
                    dish.tags.forEach((tag) => {
                      if (tag.tag_category_id === 2) return dishTagsArray.push(` ${tag.name}`);
                      if (tag.tag_category_id === 3) return dishTagsId.push(tag.id);
                    });
                    return (
                      <Table.Row key={dish && dish.id + index + dish.title}>
                        <Table.Cell>
                          <NameBlock>
                            {dish && dish.title}
                            <Icon
                              size="big"
                              name="info circle"
                              color="blue"
                              onClick={() => openDishInfoModal(dish)}
                            />
                          </NameBlock>
                        </Table.Cell>
                        <Table.Cell>
                          <Button
                            onClick={() => setIsOpenDishInfoArrayDown(index)}
                            color="blue"
                            icon
                            size="tiny"
                          >
                            <Icon name="long arrow alternate down" />
                          </Button>
                        </Table.Cell>
                        <Table.Cell>{defaultPortion}</Table.Cell>
                        <Table.Cell>{dish && dish.recipes[defaultPortion].calories}</Table.Cell>
                        <Table.Cell className="protein_cell">
                          {dish && dish.recipes[defaultPortion].animal_protein}
                        </Table.Cell>
                        <Table.Cell className="protein_cell">
                          {dish && dish.recipes[defaultPortion].vegetable_protein}
                        </Table.Cell>
                        <Table.Cell className="fat_cell">
                          {dish && dish.recipes[defaultPortion].saturated_fat}
                        </Table.Cell>
                        <Table.Cell className="fat_cell">
                          {dish && dish.recipes[defaultPortion].unsaturated_fats}
                        </Table.Cell>
                        <Table.Cell className="arbohydrates_cell">
                          {dish && dish.recipes[defaultPortion].simple_carbohydrates}
                        </Table.Cell>
                        <Table.Cell className="arbohydrates_cell">
                          {dish && dish.recipes[defaultPortion].complex_carbohydrates}
                        </Table.Cell>
                        <Table.Cell>{dish && dish.recipes[defaultPortion].cellulose}</Table.Cell>
                        <Table.Cell className="product_tags_block">
                          {dish && productTagsArray.length && (
                            <div className="product_tags" data-title={productTagsArray}>
                              {productTagsArray[0]}
                            </div>
                          )}
                        </Table.Cell>
                        <Table.Cell className="product_tags_block">
                          {dish && dishTagsArray.length && (
                            <React.Fragment>
                              <MealTagsBlock>
                                <Icon
                                  name="circle"
                                  size="small"
                                  color={dishTagsId.includes(breakfastTagId) ? 'blue' : 'grey'}
                                />
                                <Icon
                                  name="circle"
                                  size="tiny"
                                  color={dishTagsId.includes(breakfastSnackId) ? 'blue' : 'grey'}
                                />
                                <Icon
                                  name="circle"
                                  size="small"
                                  color={dishTagsId.includes(lunchTagId) ? 'blue' : 'grey'}
                                />
                                <Icon
                                  name="circle"
                                  size="tiny"
                                  color={dishTagsId.includes(lunchSnackId) ? 'blue' : 'grey'}
                                />
                                <Icon
                                  name="circle"
                                  size="small"
                                  color={dishTagsId.includes(dinnerTagId) ? 'blue' : 'grey'}
                                />
                                <Icon
                                  name="circle"
                                  size="tiny"
                                  color={dishTagsId.includes(dinnerSnackId) ? 'blue' : 'grey'}
                                />
                              </MealTagsBlock>
                              <div className="product_tags" data-title={dishTagsArray}>
                                {`${dishTagsArray[0]}  ${dishTagsArray.length > 1 ? '+' : ''}`}
                              </div>
                            </React.Fragment>
                          )}
                        </Table.Cell>
                        <Table.Cell>
                          <ButtonBlock>
                            <EditButton
                              onClick={() => onEditClick(dish)}
                              to={`/youslim2.0/dish/${dish.id}/edit`}
                              target="_blank"
                            >
                              <Img src={EditIcon} alt="edit" />
                            </EditButton>
                            <DeleteButton onClick={() => confirmDeleting(dish.title, dish.id)}>
                              x
                            </DeleteButton>
                          </ButtonBlock>
                        </Table.Cell>
                      </Table.Row>
                    );
                  }
                })}
              </Table.Body>
            </Table>
          ) : (
            <LoaderBlock>
              {isSearchDishLoading ? (
                <Loader active={isSearchDishLoading} inline="centered" />
              ) : (
                <H2>Блюда не найдены</H2>
              )}
            </LoaderBlock>
          )}
        </TableBlock>
        <FooterBlock />
        <DeleteConfirmPopup
          isOpen={isShowDeletePopup}
          title={dishCurrentName}
          onCancel={() => setIsShowDeletePopup(false)}
          onDelete={onDelete}
        />
        <DishInfoModal
          title={dishCurrentName}
          isOpen={isShowDishInfoModal}
          isLoadingDelete={isDishLoading}
          productsRows={currentProduct}
          onClose={() => setIsShowDishInfoModal(false)}
        />
      </React.Fragment>
    );
  },
);

const mapStateToProps = (state) => {
  const {
    allRecipeTags,
    allEatingTags,
    dishes,
    isSearchDishLoading,
    allTags,
    products,
    productToFind,
    isDishLoading,
  } = state.newYouslim;
  return {
    allRecipeTags,
    allEatingTags,
    dishes,
    isSearchDishLoading,
    allTags,
    products,
    productToFind,
    isDishLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getRecipeTags: (tags) => {
      dispatch(action.getRecipeTags(tags));
    },
    getProductTags: (tags) => {
      dispatch(action.getProductTags(tags));
    },
    getEatingTags: (tags) => {
      dispatch(action.getEatingTags(tags));
    },
    createProduct: (data, clear) => {
      dispatch(action.createProduct(data, clear));
    },
    getDishListByName: (name, tags) => {
      dispatch(action.getDishListByName(name, tags));
    },
    setCurrentDish: (product) => {
      dispatch(action.setCurrentDish(product));
    },
    deleteDish: (id) => {
      dispatch(action.deleteDish(id));
    },
    getProductsByName: (name) => {
      dispatch(action.getProductsByName(name));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DishListPage);



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/DishListPage/index.jsx